<script>
    import { onMount } from 'svelte';
    import { firebase, firestore } from "../../firebase/firebase.js";
    import { Navigate, Route, navigateTo } from 'svelte-router-spa';
    import { theRoute } from "../../store/shared.js";
    import { user, userProfile } from "../../store/auth.js";

    export let currentRoute;
    export let params;

    var currentLangDecks = [];
    var loader = false;
    var canFetch = false;

    $: {
        if (currentRoute && $userProfile)
            fetchCurrentLangDecks();
    }

    async function fetchCurrentLangDecks() {
        if ($userProfile) {
            canFetch = false;

            if ($userProfile.role == 'admin') {
                canFetch = true;
            } else {
                if ($userProfile.role == 'manager' && $userProfile.countries && $userProfile.countries[currentRoute.namedParams['countryId']] && $userProfile.countries[currentRoute.namedParams['countryId']].includes(currentRoute.namedParams['lang'])) {
                    canFetch = true
                }
            }

            if (canFetch) {
                currentLangDecks = [];
                loader = true;
                var res = await firestore.collection('decks').where('language', '==', currentRoute.namedParams['lang']).orderBy('created_at').get()
                if (res && res.docs && res.docs.length != 0) {
                    currentLangDecks = res.docs;
                }
                loader = false;
            }
        }
    }

    function newDeck() {
        navigateTo($theRoute.path + '/new')
    }
</script>

{#if canFetch}
<div class="decks-container">
    <div class="my_header">
        <div>
            Decks
        </div>
        <button type="button" class="btn btn-outline-primary btn-sm">
            <Navigate to="{$theRoute.path + '/new'}">
                NEW
            </Navigate>
        </button>
    </div>
    <div>
        <div style="padding: 10px">
            {#if currentLangDecks && currentLangDecks.length != 0}
                <div class="gallery" id="gallery">
                    {#each currentLangDecks as deck}
                        <div class="mb-3 pics animation all 2" style="cursor: pointer; background-color: gray; min-height: 200px; width: 100%;">
                            <Navigate to="{$theRoute.path + '/' + deck.id}">
                                <img class="img-fluid" style="width: 100%;" src="{deck.data()['image']['url']}">
                            </Navigate>
                        </div>
                    {/each}
                </div>
            {:else}
                {#if !loader}
                <div class="center">
                    <div class="d-flex justify-content-center align-items-center h-100 mt-5">
                        No Decks
                    </div>
                </div>
                {/if}
            {/if}
        </div>
    
        {#if loader}
        <div class="center">
            <div class="d-flex justify-content-center align-items-center h-100 mt-5">
                <div class="spinner-grow text-secondary" style="width: 4rem; height: 4rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        {/if}
    </div>
</div>
{/if}
<style>
    .decks-container {
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .gallery {
        -webkit-column-count: 3;
        -moz-column-count: 3;
        column-count: 3;
        -webkit-column-width: 33%;
        -moz-column-width: 33%;
        column-width: 33%;
    }

    .gallery .pics {
        -webkit-transition: all 350ms ease;
        transition: all 350ms ease;
    }

    .gallery .animation {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    @media (max-width: 450px) {
        .gallery {
            -webkit-column-count: 1;
            -moz-column-count: 1;
            column-count: 1;
            -webkit-column-width: 100%;
            -moz-column-width: 100%;
            column-width: 100%;
        }
    }

    @media (max-width: 400px) {
        .btn.filter {
            padding-left: 1.1rem;
            padding-right: 1.1rem;
        }
    }

    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .center{
        width: 100%; float: left; top: 0; bottom: 0; left: 0; right: 0;
    }
</style>